import React from 'react';

const GreenCheck = props => (
  <svg
    width="188"
    viewBox="0 0 188 188"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M75.6095 123.65L50.0455 98.0856L41.3403 106.73L75.6095 140.999L149.175 67.4335L140.531 58.7896L75.6095 123.65Z"
      fill="#42B44A"
    />
    <circle cx="94" cy="94" r="91" stroke="#42B44A" strokeWidth="6" />
  </svg>
);

export default GreenCheck;
